export class ContactImplPersonal {
    constructor(ctx) {
        this.ctx = ctx;
    }
    async doGetPersonalOrg(params) {
        var _a;
        const _account = params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.ctx.contactPersonalHelper.doGetPersonalOrg(Object.assign(Object.assign({}, params), { _account }));
    }
    doInsertPersonalOrg(params) {
        var _a;
        const _account = params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.ctx.contactPersonalHelper.doInsertPersonalOrg(Object.assign(Object.assign({}, params), { _account }));
    }
    doUpdatePersonalOrg(params) {
        var _a;
        const _account = params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.ctx.contactPersonalHelper.doUpdatePersonalOrg(Object.assign(Object.assign({}, params), { _account }));
    }
    async doInsertContactByPersonalOrgId(params) {
        var _a;
        const _account = params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.ctx.contactPersonalHelper.doInsertContactByPersonalOrgId(Object.assign(Object.assign({}, params), { _account }));
    }
    async doDeletePersonalOrg(params) {
        return this.ctx.contactPersonalHelper.doDeletePersonalOrg(params);
    }
    async doGetPersonalOrgContactByOrgId(params) {
        return this.ctx.contactPersonalHelper.doGetPersonalOrgContactByOrgId(params);
    }
    async doGetPersonalNoGroupContact(_account) {
        const list = await this.doGetPersonalContact({ _account });
        const res = [];
        list === null || list === void 0 ? void 0 : list.forEach(item => {
            var _a, _b;
            if (!((_b = (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.personalOrg) === null || _b === void 0 ? void 0 : _b.length)) {
                res.push(item);
            }
        });
        return res;
    }
    async doGetPersonalContact(option) {
        return this.ctx.contactPersonalHelper.doGetPersonalContact(option);
    }
    async doUpdateContact(_params) {
        var _a;
        const _account = _params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.ctx.contactPersonalHelper.doUpdateContact(Object.assign(Object.assign({}, _params), { _account }));
    }
    async doDeleteContact(params) {
        var _a;
        const _account = params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.ctx.contactPersonalHelper.doDeleteContact(Object.assign(Object.assign({}, params), { _account }));
    }
    async doInsertContact(params) {
        var _a;
        const _account = params._account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        return this.ctx.contactPersonalHelper.doInsertContact(Object.assign(Object.assign({}, params), { _account }));
    }
    async doGetOrgContactListByContactId(_idList) {
        console.warn('[contact] doGetOrgContactListByContactId is deprecated');
        return [];
    }
    async uploadIcon(params) {
        return this.ctx.contactServer.uploadIcon(params);
    }
    async deleteAvatarIcon() {
        return this.ctx.contactServer.deleteAvartIcon();
    }
    async doImportPersonalContact(params) {
        return this.ctx.contactPersonalHelper.importPersonalContact(params);
    }
    async doExportPersonalContact(params) {
        return this.ctx.contactPersonalHelper.exportPersonalContact(params);
    }
    async doExportPersonalContactTemplate(type) {
        return this.ctx.contactPersonalHelper.exportPersonalContactTemplate(type);
    }
}
